var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"text-muted"},[_c('b-icon',{staticStyle:{"margin-right":"15px"},attrs:{"icon":"info-circle","scale":"1.5"}}),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('item.info')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }